export interface ITag {
  variant?: TAG_VARIANT;
  solid?: boolean;
  label?: string;
}

export enum TAG_VARIANT {
  BRAND = 'BRAND',
  ACCENT1 = 'ACCENT1',
  ACCENT2 = 'ACCENT2',
  ACCENT3 = 'ACCENT3',
  NEUTRAL_LIGHT = 'NEUTRAL_LIGHT',
  NEUTRAL_DARK = 'NEUTRAL_DARK'
}
